import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthGuard } from '../../hooks/useAuthGuard.ts';
import { ROUTE_NAME_OPTIONS } from '../../utils/constants.ts';
import Loading from '../loading/Loading.tsx';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthGuard();

  if (isLoading) {
    return <Loading fullScreen={true} />;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${ROUTE_NAME_OPTIONS.LOGIN}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
